import { connect } from 'react-redux';
import { getEditorDraft } from '../../../DaEditorWrapper/redux/selectors';
import { isInitialized, getCommentState } from '../../redux/selectors';
import { generateReplyEditorId } from '../../utils';
const getPropWithSelector = (state, commentId, selector, defaultValue)=>{
    if (isInitialized(commentId)(state)) {
        return selector(commentId)(state);
    }
    return defaultValue;
};
const mapStateToProps = (state, ownProps)=>({
        comment: getPropWithSelector(state, ownProps.comment.commentId, getCommentState, ownProps.comment),
        hasReplyDraft: !!getEditorDraft(state, generateReplyEditorId(ownProps.comment))
    });
export default connect(mapStateToProps);
